import PropTypes from 'prop-types';

const EnvelopeIllustration = ({ className = '' }) => {
  return (
    <svg
      width="98"
      height="72"
      viewBox="0 0 98 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M97.4934 0.228516H0.666748V71.2285H97.4934V0.228516Z"
        fill="#FFCCEF"
      />
      <path
        d="M0.666748 0.228516H97.4934L49.0749 48.6367L0.666748 0.228516Z"
        fill="#FB6E44"
      />
    </svg>
  );
};

EnvelopeIllustration.propTypes = {
  className: PropTypes.string
};

export default EnvelopeIllustration;
